/* eslint-disable */
import { auth } from '@/plugins/auth/firebase.js'
import Cookie from 'js-cookie'
import JWTDecode from 'jwt-decode'
import axios from 'axios'
import * as vars from '@/vars.json'

const httpAxios = axios.create({
    params: {},
})

export const clients = {
    namespaced: true,
    state: {
        clients_list: [],
        currentItem: {},
        isLoading: false,
    },

    mutations: {

        SET_CLIENTS_LIST (state, payload) {
            state.clients_list = payload
        },
        SET_LOADING (state, payload) {
            state.isLoading = payload
        },
        SET_CURRENT_ITEM (state, payload) {
            state.currentItem = payload
        },
    },

    actions: {
        async loadClients ({ commit, state, rootState, dispatch }) {
             return new Promise((resolve, reject) => {
                // console.log('cargando clientes')
                commit('SET_LOADING', true)
                let userId = ''
                if(rootState.users.user.adminUid){
                    userId = rootState.users.user.adminUid
                }else{
                    userId = rootState.users.user.uid
                }
                // console.log(userId)
                let path = `users/${userId}/transactions/clients`
                let loadCommit = 'SET_CLIENTS_LIST'

                 firebase.database().ref(path).orderByChild('name').on('value',
                    function (data) {
                      let items = Object.values(data.val()) || [];
                        // console.log(items)
                        commit(loadCommit, items)
                        commit('SET_LOADING', false)
                        resolve()
                    }, function (error) {
                        console.error(error)
                        dispatch('users/showErrorSessionExpired', null, {root:true})
                        commit('SET_LOADING', false)
                        reject()
                    },
                )
            })
        },
        async addUpdateClient ({ commit, state, rootState }, payload) {
            return new Promise((resolve, reject) => {
                httpAxios.post(vars.url + '/addUpdateClient', payload).then((response) => {
                  resolve(response.data)
                }).catch((error) => {
                  reject(error)
                });
            });
        },
        /* async createClient ({ commit, state, rootState }, payload) {
            commit('SET_LOADING', true)
            let userId = ''
            if(rootState.users.user.adminUid){
                userId = rootState.users.user.adminUid
            }else{
                userId = rootState.users.user.uid
            }
            const id = payload.id ? payload.id : firebase.database().ref().child(`users/${userId}/providers`).push().key
            payload.id = id
            // console.log(payload)
            await firebase.database().ref().child(`users/${userId}/transactions/clients/${payload.id}`).update(payload).then(function () {
                setTimeout(function () {
                    commit('SET_LOADING', false)
                }, 500)
            })
        },
        async  updateClient ({ commit, state, rootState }, payload) {
            commit('SET_LOADING', true)
            const vm = this
            let userId = ''
            if(rootState.users.user.adminUid){
                userId = rootState.users.user.adminUid
            }else{
                userId = rootState.users.user.uid
            }
            const itemData = payload
            await firebase.database().ref(`users/${userId}/transactions/clients/${itemData.id}`).update(itemData).then(function () {
                    // updated!
                commit('SET_LOADING', false)
            }).catch(function (err) {
                commit('SET_LOADING', false)
                throw err
            })
        }, */
        setCurrentItem({ commit, state, rootState }, payload) {
            // commit('SET_LOADING', true);
            const vm = this
            let userId = ''
            if (rootState.users.user.adminUid) {
                userId = rootState.users.user.adminUid
            } else {
                userId = rootState.users.user.uid
            }
            if (payload) {
                return new Promise((resolve, reject) => {
                    const path = `users/${userId}/transactions/clients`
                    const setCommit = 'SET_CURRENT_ITEM'
                    let id

                    try {
                        const currentItem = state.clients_list.find(item => item.id === payload.id)
                        // console.log(currentItem)
                        if (!payload.id) {
                            id = currentItem.id
                        } else {
                            id = payload.id
                        }
                        const dbRef = firebase.database().ref()
                        let item
                        dbRef.child(path + '/' + id).on('value', function (data) {
                            // console.log(data.val(), id)
                            item = {
                                ...data.val(),
                                id: data.key,
                            }
                            commit(setCommit, item)
                            // commit('setLoading', false);
                            resolve()
                        }, function (error) {
                            // console.log(error)
                            // commit('setLoading', false);
                            reject()
                        })
                    } catch (err) {
                        reject()
                        // console.log(err)
                    }
                })
            } else {
                commit('SET_CURRENT_ITEM', {})
            }
        },
        async deleteClient ({ commit, state, rootState }, payload) {
            // console.log(payload)
            let userId = ''
            if(rootState.users.user.adminUid){
                userId = rootState.users.user.adminUid
            }else{
                userId = rootState.users.user.uid
            }
            commit('SET_LOADING', true)
            await firebase.database().ref().child(`users/${userId}/transactions/clients/${payload.id}`).remove().then(function () {
                commit('SET_LOADING', false)
            }).catch(function(error){
                // console.log(error)
                commit('SET_LOADING', false)
            })
        },

    },
    getters: {
        getClients (state) {
            return state.clients_list
        },
        getCurrentItem (state) {
            return state.currentItem
        },
    },

}
